/*
 * Define a form page to display a list of Allegations.
 * Include the Other input option.
 * The list of allegations (choices) must be provided by the calling function.
 */
import css from './pages.module.css'
import { otherChoicePage } from './choicePage'

export const allegationPage = propOverrides => {
  const props = {
    pageId: 'allegation_page',
    fieldName: 'allegation',
    choices: [],
    label: 'Which fraudulent action are you reporting?',
    className: css.choices,
    labelClassName: css.largeLabel,
    fieldNameOther: 'allegation_other',
    labelOther: 'Please enter the fraudulent action',
    ...propOverrides
  }

  return otherChoicePage({ ...props })
}
